import { render, staticRenderFns } from "./TopLocationBackgroundShape4.vue?vue&type=template&id=60c2d053&scoped=true&"
import script from "./TopLocationBackgroundShape4.vue?vue&type=script&lang=js&"
export * from "./TopLocationBackgroundShape4.vue?vue&type=script&lang=js&"
import style0 from "./TopLocationBackgroundShape4.vue?vue&type=style&index=0&id=60c2d053&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2d053",
  null
  
)

export default component.exports